// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1hqBN","head":"Table_head__17UWc","col":"Table_col__xASi8"};